// _           __   ___   _____    __   _   _   __   _   _____
// | |        / /  /   | |  _  \  |  \ | | | | |  \ | | /  ___|
// | |  __   / /  / /| | | |_| |  |   \| | | | |   \| | | |
// | | /  | / /  / / | | |  _  /  | |\   | | | | |\   | | |  _
// | |/   |/ /  / /  | | | | \ \  | | \  | | | | | \  | | |_| |
// |___/|___/  /_/   |_| |_|  \_\ |_|  \_| |_| |_|  \_| \_____/

// THIS FILE IS AUTO GENERATED!!!!!!
// DO NO EDIT IT HERE.

// THE TEMPLATE IS AT: tasks/pkg/icon-template/src/index.tsx

import baseIcon, { defaultIconGroupProps } from '@bubble-ui/temp-icon-base';
var IconWarningPath = 'M16.229 8.674a32.833 32.833 0 0 1 3.437 7.976l.24.857-.823.338a24.266 24.266 0 0 1-9.13 1.794c-3.113 0-6.269-.62-9.13-1.794L0 17.507l.24-.857a32.875 32.875 0 0 1 3.438-7.976A33.864 33.864 0 0 1 9.26 1.667L9.953 1l.694.667a33.9 33.9 0 0 1 5.582 7.007ZM5.395 9.702a30.843 30.843 0 0 0-2.97 6.618c4.782 1.73 10.27 1.73 15.057 0a30.843 30.843 0 0 0-2.97-6.618 31.811 31.811 0 0 0-4.56-5.906 31.765 31.765 0 0 0-4.557 5.906Zm3.558 2.312h2v-5h-2v5Zm-.5 2.5a1.5 1.5 0 1 1 3.001 0 1.5 1.5 0 0 1-3 0Z';
var IconWarning = baseIcon('IconWarning', {
  groupProps: defaultIconGroupProps,
  getPath: () => IconWarningPath
});
export default IconWarning;
//# sourceMappingURL=index.js.map